import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../../api";
import { toast } from "react-toastify";
import {
  FaFilter,
  FaTools,
  FaCheckCircle,
  FaClock,
  FaExclamationTriangle,
  FaBuilding,

} from "react-icons/fa";
import AddPerBangunan from "../../components/bangunan/AddPerBangunan";
import dayjs from "dayjs";
import DataPerBangunan from "../../components/bangunan/DataPerBangunan";
import StatBangunan from "../../components/bangunan/StatBangunan";
import { prepareImageForUpload } from "../../utils/imageCompress";
import { SipDropdown, SipSearch } from "../../components/form/SipControls";

function PerawatanBangunan() {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  // ==================== STATE MANAGEMENT ====================
  // State untuk pencarian dan filter
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [jenisKerusakanFilter, setJenisKerusakanFilter] = useState("");

  // State untuk data dan loading
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // State untuk modal dan form
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState({
    id: "",
    bagian: "",
    jenis_kerusakan: "",
    tindakan: "",
    foto: null,
    tgl_masuk: "",
    tgl_selesai: "",
    foto_sebelum: null,
    foto_sesudah: null,
    petugas: "",
    ket: "",
    status: "",
  });

  const resetData = () => {
    setForm({
      id: "",
      bagian: "",
      jenis_kerusakan: "",
      tindakan: "",
      foto: null,
      tgl_masuk: "",
      tgl_selesai: "",
      foto_sebelum: null,
      foto_sesudah: null,
      petugas: "",
      ket: "",
      status: "",
    });
  };

  // ==================== USEEFFECT ====================
  useEffect(() => {
    getDataBangunan();
  }, []);

  // ==================== UTILITY FUNCTIONS ====================
  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "selesai":
        return <FaCheckCircle className="text-green-500" />;
      case "proses":
        return <FaClock className="text-yellow-500" />;
      case "pending":
        return <FaExclamationTriangle className="text-red-500" />;
      default:
        return <FaClock className="text-gray-500" />;
    }
  };

  const getStatusBadge = (status) => {
    const baseClasses = "px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1";
    switch (status?.toLowerCase()) {
      case "selesai":
        return `${baseClasses} bg-green-100 text-green-800`;
      case "proses":
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case "pending":
        return `${baseClasses} bg-red-100 text-red-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  };

  // ==================== FILTER AND SEARCH FUNCTIONS ====================
  const filteredData = rows.filter((item) => {
    const matchesSearch = 
      item.bagian?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.nama_bagian?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.jenis_kerusakan?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.petugas?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.pic?.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = statusFilter === "all" || item.status === statusFilter;
    const matchesJenisKerusakan = jenisKerusakanFilter === "" || item.jenis_kerusakan === jenisKerusakanFilter;
    
    return matchesSearch && matchesStatus && matchesJenisKerusakan;
  });

  // ==================== MODAL FUNCTIONS ====================
  const openModal = (item = null) => {
    if (item) {
      setForm(item);
      setIsEditing(true);
    } else {
      resetData();
      setIsEditing(false);
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetData();
    setIsEditing(false);
  };

  const openDetailModal = (id) => {
    const rowData = rows.find((item) => item.id === id);
    setSelectedItem(rowData);
    setIsDetailModalOpen(true);
  };

  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
    setSelectedItem(null);
  };

  // ==================== FORM HANDLERS ====================
  

 

  // ==================== DELETE FUNCTION ====================
  const handleDelete = async (id) => {
     try {
      // Add id to deleting set
      
      await Api.delete(`/mon/perawatan-bangunan/${id}`);
      toast.success("Data berhasil dihapus!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      getDataBangunan()
    } catch (error) {
      console.error("Error deleting data:", error);
      toast.error("Gagal menghapus data. Silakan coba lagi.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } 
  };

   // ==================== EDIT FUNCTION ====================
  const handleEdit = async (id) => {
    try {
      const res = await Api.get(`/mon/perawatan-bangunan/${id}`);
      setForm({
        id: res.data.data.id,
        bagian: res.data.data.nama_bagian || "",
        jenis_kerusakan: res.data.data.jenis_kerusakan || "",
        tgl_masuk: res.data.data.tgl_masuk ? dayjs(res.data.data.tgl_masuk).format("YYYY-MM-DD") : "",
        tgl_selesai: res.data.data.tgl_selesai ? dayjs(res.data.data.tgl_selesai).format("YYYY-MM-DD") : "",
        tindakan: res.data.data.tindakan || "",
        foto: res.data.data.foto || null,
        foto_sebelum: res.data.data.befoto || null,
        foto_sesudah: res.data.data.lasfoto || null,
        petugas: res.data.data.pic || "",
        ket: res.data.data.ket || "",
        status: res.data.data.status || "",
      });
      setIsEditing(true);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching data for edit:", error);
      toast.error("Gagal mengambil data untuk edit!");
    }
  };

  // ==================== API FUNCTIONS ====================
  const postBangunan = async () => {
    try {
      const formData = new FormData();
      formData.append("id", form.id);
      formData.append("nama_bagian", form.bagian);
      formData.append("jenis_kerusakan", form.jenis_kerusakan);
      formData.append("tindakan", form.tindakan);
      formData.append("tgl_masuk", form.tgl_masuk);
      formData.append("tgl_selesai", form.tgl_selesai);
      formData.append("petugas", form.petugas);
      formData.append("ket", form.ket);
      formData.append("status", form.status);
      formData.append("desc", form.desc || "");

      // Hanya kirim file baru — pastikan sudah dikompres (aman untuk foto HP/tablet besar)
      if (form.foto_sebelum instanceof File) {
        const befoto = await prepareImageForUpload(form.foto_sebelum);
        if (befoto) formData.append("befoto", befoto);
      }
      if (form.foto_sesudah instanceof File) {
        const lasfoto = await prepareImageForUpload(form.foto_sesudah);
        if (lasfoto) formData.append("lasfoto", lasfoto);
      }
      await Api.post("/mon/perawatan-bangunan", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      resetData();
      toast.success("Laporan kerusakan berhasil dikirim!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setIsModalOpen(false);
      getDataBangunan();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error("Gagal mengirim laporan: " + error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.error("Gagal mengirim laporan. Silakan coba lagi.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  };

  const getDataBangunan = async () => {
    try {
      setLoading(true);
      // Membangun query parameters
      const params = new URLSearchParams();

      const queryString = params.toString();
      const url = `/mon/perawatan-bangunan${queryString ? `?${queryString}` : ""}`;

      const res = await Api.get(url);
      setRows(res.data.data || []);
      setError(null);
    } catch (error) {
      console.error("Error fetching perawatan data:", error);
      setError("Gagal mengambil data perawatan. Silakan coba lagi.");
      setRows([]);
    } finally {
      setLoading(false);
    }
  };
  

 

  return (
    <div className="space-y-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* ==================== HEADER SECTION ==================== */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          <div className="bg-primary px-6 py-8 md:px-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              {/* Judul Halaman */}
              <div className="text-white animate__animated animate__fadeInLeft animate__delay-2s">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 bg-white/20 rounded-lg animate__animated animate__pulse animate__infinite animate__slower">
                    <FaBuilding className="text-xl" />
                  </div>
                  <h1 className="text-2xl md:text-3xl font-bold">
                    Perawatan Bangunan
                  </h1>
                </div>
                <p className="text-primary text-sm md:text-base">
                  Pantau dan kelola perawatan dan perbaikan bangunan
                </p>
              </div>

              {/* Tombol Kembali */}
              <button
                onClick={handleBack}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/20 px-4 py-3 rounded-xl hover:bg-white/20 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                <span className="font-medium">Kembali</span>
              </button>
            </div>
          </div>
        </div>

        {/* ==================== SEARCH AND FILTER SECTION ==================== */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">
          <div className="mb-6 flex flex-col gap-4 xl:flex-row">
            {/* Search Bar */}
            <div className="min-w-0 w-full flex-1">
              <SipSearch
                placeholder="Cari berdasarkan bagian, jenis kerusakan, atau petugas..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Add Button */}
           <AddPerBangunan 
             openModal={openModal} 
             isModalOpen={isModalOpen} 
             setIsModalOpen={setIsModalOpen} 
             isEditing={isEditing}
             setIsEditing={setIsEditing}
             form={form} 
             setForm={setForm} 
             closeModal={closeModal} 
             postBangunan={postBangunan} 
           />
          </div>

          {/* Filter Controls */}
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
            {/* Status Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <FaFilter className="inline mr-2" />
                Status
              </label>
              <SipDropdown
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                options={[
                  { label: "Semua Status", value: "all" },
                  { label: "Pending", value: "pending" },
                  { label: "Proses", value: "proses" },
                  { label: "Selesai", value: "selesai" },
                ]}
              />
            </div>

            {/* Jenis Kerusakan Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <FaTools className="inline mr-2" />
                Jenis Kerusakan
              </label>
              <SipDropdown
                value={jenisKerusakanFilter}
                onChange={(e) => setJenisKerusakanFilter(e.target.value)}
                placeholder="Semua Jenis"
                options={[
                  { label: "Semua Jenis", value: "" },
                  "Atap", "Dinding", "Lantai", "Pintu", "Jendela", "Plafon", "Listrik", "Catu Daya", "Plumbing",
                ].map((item) => typeof item === "string" ? { label: item, value: item } : item)}
              />
            </div>

            {/* Reset Filters */}
            <div className="flex items-end">
              <button
                onClick={() => {
                  setSearchTerm("");
                  setStatusFilter("all");
                  setJenisKerusakanFilter("");
                }}
                className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all duration-300"
              >
                Reset Filter
              </button>
            </div>
          </div>
        </div>

        {/* ==================== BANGUNAN STATISTICS ==================== */}
        <StatBangunan rows={rows}/>

        {/* ==================== DATA TABLE SECTION ==================== */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-800">
                Data Perawatan Bangunan
              </h2>
              <span className="text-sm text-gray-500">
                Total: {filteredData.length} data
              </span>
            </div>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              <span className="ml-3 text-gray-600">Memuat data...</span>
            </div>
          ) : error ? (
            <div className="flex items-center justify-center py-12">
              <div className="text-center">
                <FaExclamationTriangle className="mx-auto h-12 w-12 text-red-500 mb-4" />
                <p className="text-red-600">{error}</p>
                <button
                  onClick={getDataBangunan}
                  className="mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
                >
                  Coba Lagi
                </button>
              </div>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <DataPerBangunan
                currentData={filteredData}
                loading={loading}
                handleDelete={handleDelete}
                handleEdit={handleEdit}
                getStatusBadge={getStatusBadge}
                openDetailModal={openDetailModal}
                getStatusIcon={getStatusIcon}
                isDetailModalOpen={isDetailModalOpen}
                closeDetailModal={closeDetailModal}
                selectedItem={selectedItem}
              />
            </div>
          )}
        </div>

       

      
      </div>
    </div>
  );
}

export default PerawatanBangunan;